/* Accessibility fixes (2026-10-08, extended 2026-10-09 and 2026-10-26). Loaded by snippets/fl-a11y.liquid.
   Keyboard and screen-reader behaviour for the slide-out panels (cart, sign in, menu, search) and the
   drop-down menus, names for unnamed controls, the cart count, product photo descriptions, heading levels,
   and previous / next / pause controls for auto-rotating content. */
(function () {
  'use strict';
  if (window.__flA11y) return;
  window.__flA11y = true;

  var doc = document;
  var FOCUSABLE = 'a[href],button:not([disabled]),input:not([disabled]):not([type="hidden"]),select:not([disabled]),textarea:not([disabled]),[tabindex]:not([tabindex="-1"])';

  function all(sel, root) { return Array.prototype.slice.call((root || doc).querySelectorAll(sel)); }
  function shown(el) {
    if (!el) return false;
    var r = el.getBoundingClientRect();
    var cs = window.getComputedStyle(el);
    return r.width > 0 && r.height > 0 && cs.visibility !== 'hidden' && cs.display !== 'none';
  }
  function text(el) { return (el.textContent || '').replace(/\s+/g, ' ').trim(); }

  /* ---------- Spoken messages (a polite live region) ---------- */
  var liveEl = null;
  function say(msg) {
    if (!liveEl) {
      liveEl = doc.createElement('div');
      liveEl.id = 'fl-a11y-live'; liveEl.className = 'fl-a11y-sr';
      liveEl.setAttribute('role', 'status'); liveEl.setAttribute('aria-live', 'polite');
      doc.body.appendChild(liveEl);
    }
    liveEl.textContent = '';
    window.setTimeout(function () { liveEl.textContent = msg; }, 80);
  }

  /* ---------- Slide-out panels ---------- */
  var PANELS = [
    { id: 'halo-cart-sidebar', label: 'Shopping cart', open: 'cart-sidebar-show', triggers: '[data-cart-sidebar]' },
    { id: 'halo-auth-sidebar', label: 'Sign in', open: 'auth-sidebar-show', triggers: '[data-open-auth-sidebar]' },
    { id: 'navigation-mobile', label: 'Menu', open: 'menu_open', triggers: '[data-mobile-menu]' },
    { id: 'halo-quick-view-popup', label: 'Quick view', open: 'quick-view-show', triggers: '[data-open-quick-view-popup]' }
  ];
  var current = null;      // panel that is open now
  var lastTrigger = null;  // control that opened it

  function panelEl(p) { return doc.getElementById(p.id); }
  function isOpen(p) { return doc.body.classList.contains(p.open); }
  function closeButton(el) {
    var list = all('.halo-sidebar-close,[data-close-cart-sidebar],[data-close-auth-sidebar],[data-menu-close-sidebar],[data-close-quick-view-popup]', el);
    for (var i = 0; i < list.length; i++) { if (shown(list[i])) return list[i]; }
    return list[0] || null;
  }
  function focusables(el) { return all(FOCUSABLE, el).filter(shown); }

  function describePanels() {
    PANELS.forEach(function (p) {
      var el = panelEl(p);
      if (!el) return;
      if (!el.getAttribute('role')) el.setAttribute('role', 'dialog');
      if (!el.getAttribute('aria-label') && !el.getAttribute('aria-labelledby')) el.setAttribute('aria-label', p.label);
      el.setAttribute('aria-modal', 'true');
      if (!el.hasAttribute('tabindex')) el.setAttribute('tabindex', '-1');
      all(p.triggers).forEach(function (t) {
        t.setAttribute('aria-haspopup', 'dialog');
        t.setAttribute('aria-controls', p.id);
        t.setAttribute('aria-expanded', isOpen(p) ? 'true' : 'false');
        if (t.tagName === 'A' && !t.getAttribute('role')) t.setAttribute('role', 'button');
      });
    });
  }

  function onPanelKey(e) {
    if (!current) return;
    var el = panelEl(current);
    if (!el) return;
    if (e.key === 'Escape' || e.key === 'Esc') {
      // phone menu: Escape inside an open sub-menu goes back one level first
      if (current.id === 'navigation-mobile') {
        var subLi = doc.activeElement && doc.activeElement.closest ? doc.activeElement.closest('li.menu-lv-1.is-open') : null;
        var backBtn = subLi ? subLi.querySelector('.nav-title-mobile[role="button"]') : null;
        if (backBtn) { e.preventDefault(); e.stopPropagation(); backBtn.click(); return; }
      }
      var c = closeButton(el);
      if (c) { e.preventDefault(); c.click(); }
      return;
    }
    if (e.key !== 'Tab') return;
    var f = focusables(el);
    if (!f.length) { e.preventDefault(); el.focus(); return; }
    var first = f[0], last = f[f.length - 1], a = doc.activeElement;
    if (!el.contains(a)) { e.preventDefault(); first.focus(); return; }
    if (e.shiftKey && a === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && a === last) { e.preventDefault(); first.focus(); }
  }

  function focusInto(el) {
    if (el.contains(doc.activeElement)) return;
    var target = closeButton(el);
    if (!target || !shown(target)) target = focusables(el)[0] || el;
    try { target.focus(); } catch (err) {}
  }

  function syncPanels() {
    // the closed off-screen mobile menu must not take focus (2.4.3, 2.4.7); 'inert' also hides it from screen readers
    var navM = doc.getElementById('navigation-mobile');
    if (navM && 'inert' in navM) {
      var navOpen = doc.body.classList.contains('menu_open');
      if (navM.inert === navOpen) navM.inert = !navOpen;
    }
    var nowOpen = null;
    PANELS.forEach(function (p) { if (!nowOpen && panelEl(p) && isOpen(p)) nowOpen = p; });
    describePanels();
    if (nowOpen && nowOpen !== current) {
      current = nowOpen;
      var el = panelEl(nowOpen);
      if (!lastTrigger || !doc.body.contains(lastTrigger)) lastTrigger = doc.activeElement && doc.activeElement !== doc.body ? doc.activeElement : null;
      // The theme may put focus back on the button that opened the panel (it does after "Add to cart"),
      // and the panel is not focusable until it has slid in: try a few times until focus is inside.
      [350, 800, 1500, 2600].forEach(function (ms) {
        window.setTimeout(function () { if (current === nowOpen && isOpen(nowOpen)) focusInto(el); }, ms);
      });
    } else if (!nowOpen && current) {
      var back = lastTrigger;
      current = null; lastTrigger = null;
      if (back && doc.body.contains(back) && shown(back)) { try { back.focus(); } catch (err) {} }
    }
  }

  doc.addEventListener('keydown', onPanelKey, true);
  // an open panel is modal: focus that lands behind it is brought back
  doc.addEventListener('focusin', function (e) {
    if (!current || !isOpen(current)) return;
    var el = panelEl(current);
    if (!el || !shown(el) || el.contains(e.target)) return;
    window.setTimeout(function () { if (current && isOpen(current)) focusInto(el); }, 0);
  }, true);
  doc.addEventListener('click', function (e) {
    var t = e.target && e.target.closest ? e.target.closest('[data-cart-sidebar],[data-open-auth-sidebar],[data-mobile-menu],[data-open-quick-view-popup]') : null;
    if (t) lastTrigger = t;
  }, true);
  doc.addEventListener('keydown', function (e) {
    // the small product photos are buttons: Enter and Space switch the photo
    if ((e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') && e.target && e.target.classList && e.target.classList.contains('productView-thumbnail-link')) {
      e.preventDefault(); e.target.click(); return;
    }
    // a link that acts as a button must also answer to the space bar
    if ((e.key === ' ' || e.key === 'Spacebar') && e.target && e.target.getAttribute && e.target.getAttribute('role') === 'button' && e.target.tagName === 'A' && e.target.hasAttribute('aria-controls')) {
      e.preventDefault(); e.target.click();
    }
  });

  /* ---------- Drop-down menus in the header: open, close and state by keyboard ---------- */
  function setupMenus() {
    all('li.menu-lv-1').forEach(function (li, idx) {
      if (li.__flMenu) return;
      var link = null, sub = null;
      for (var i = 0; i < li.children.length; i++) {
        var ch = li.children[i];
        if (!link && ch.tagName === 'A') link = ch;
        if (!sub && ch.classList && ch.classList.contains('menu-dropdown')) sub = ch;
      }
      if (!link || !sub) return;
      li.__flMenu = true;
      // the mobile menu is copied from the desktop one, toggles included: drop the copies (they have no handlers)
      all(':scope > .fl-a11y-subtoggle', li).forEach(function (old) { old.parentNode.removeChild(old); });
      var mobileOpener = li.closest('#navigation-mobile') ? li.querySelector('[data-toggle-menu-mb]') : null;
      if (!sub.id) sub.id = 'fl-a11y-submenu-' + idx;
      var b = doc.createElement('button');
      b.type = 'button'; b.className = 'fl-a11y-subtoggle';
      b.setAttribute('aria-expanded', 'false'); b.setAttribute('aria-controls', sub.id);
      b.setAttribute('aria-label', text(link) + ' submenu');
      b.innerHTML = '<span aria-hidden="true">\u25BE</span>';
      li.insertBefore(b, sub);
      function set(open, focusFirst) {
        li.classList.toggle('fl-a11y-open', open);
        b.setAttribute('aria-expanded', open ? 'true' : 'false');
        if (open && focusFirst) window.setTimeout(function () { var f = focusables(sub)[0]; if (f) { try { f.focus(); } catch (err) {} } }, 80);
      }
      if (mobileOpener) {
        // phone menu: the theme slides the sub-menu in when its arrow is clicked; the button does the same by keyboard
        b.classList.add('fl-a11y-subtoggle--mb');
        var back = sub.querySelector('.nav-title-mobile');
        if (back && !back.getAttribute('role')) {
          back.setAttribute('role', 'button'); back.setAttribute('tabindex', '0');
          back.setAttribute('aria-label', 'Back to main menu');
          back.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') { e.preventDefault(); back.click(); } });
          back.addEventListener('click', function () { window.setTimeout(function () { b.setAttribute('aria-expanded', li.classList.contains('is-open') ? 'true' : 'false'); if (!li.classList.contains('is-open')) { try { b.focus(); } catch (err) {} } }, 120); });
        }
        b.addEventListener('click', function () {
          mobileOpener.click();
          window.setTimeout(function () {
            var open = li.classList.contains('is-open');
            b.setAttribute('aria-expanded', open ? 'true' : 'false');
            if (open) { var f = back || focusables(sub)[0]; if (f) { try { f.focus(); } catch (err) {} } }
          }, 150);
        });
        li.addEventListener('keydown', function (e) {
          if ((e.key === 'Escape' || e.key === 'Esc') && li.classList.contains('is-open') && back) { e.stopPropagation(); e.preventDefault(); back.click(); }
        });
        return;
      }
      b.addEventListener('click', function () { set(b.getAttribute('aria-expanded') !== 'true' || !li.classList.contains('fl-a11y-open'), false); });
      li.addEventListener('keydown', function (e) {
        if ((e.key === 'Escape' || e.key === 'Esc') && li.classList.contains('fl-a11y-open')) { e.stopPropagation(); set(false); b.focus(); }
        else if (e.key === 'ArrowDown' && (e.target === link || e.target === b)) { e.preventDefault(); set(true, true); }
      });
      li.addEventListener('focusout', function () { window.setTimeout(function () { if (!li.contains(doc.activeElement)) set(false); }, 100); });
      li.addEventListener('mouseenter', function () { b.setAttribute('aria-expanded', 'true'); });
      li.addEventListener('mouseleave', function () { if (!li.classList.contains('fl-a11y-open')) b.setAttribute('aria-expanded', 'false'); });
    });
  }

  var cartCount = null;   // last known number of items in the cart

  /* ---------- Names, roles and text alternatives ---------- */
  function fixMarkup() {
    // carousel tracks are announced as unnamed list boxes
    fixSliders();
    all('.jdgm-carousel__item-container:not([tabindex])').forEach(function (n) { n.setAttribute('tabindex', '0'); n.setAttribute('role', 'group'); n.setAttribute('aria-label', 'Customer reviews'); });

    // placeholder cards shown while products load
    all('.product-item--loadingNoInfo:not([data-fl-a11y-skel])').forEach(function (n) {
      n.setAttribute('aria-hidden', 'true'); n.setAttribute('data-fl-a11y-skel', '1');
    });
    all('[data-fl-a11y-skel]:not(.product-item--loadingNoInfo)').forEach(function (n) {
      n.removeAttribute('aria-hidden'); n.removeAttribute('data-fl-a11y-skel');
    });

    // frames need a title
    all('iframe:not([title])').forEach(function (f) {
      var id = (f.id || f.name || '').toLowerCase();
      f.setAttribute('title', id.indexOf('merchantwidget') > -1 ? 'Google customer reviews badge' : 'Embedded content');
    });

    // icons inside controls that already have a name
    all('svg[role="img"]:not([aria-label]):not([aria-labelledby])').forEach(function (s) {
      if (s.querySelector('title')) return;
      s.removeAttribute('role'); s.setAttribute('aria-hidden', 'true'); s.setAttribute('focusable', 'false');
    });

    // 2026-11-01: a note icon sits beside the note's written name, so it is hidden from screen readers; the product picture in the
    // notes block reads as the product. Built this way on every product page, the class on the picture has a stray quote in it.
    all('.hadinoteimage img').forEach(function (img) { if (!img.getAttribute('alt')) img.setAttribute('aria-hidden', 'true'); });
    all('[class*="hadiproductpicture"] img').forEach(function (img) {
      var h = doc.querySelector('h1');
      if (!img.getAttribute('alt') && h) img.setAttribute('alt', text(h));
    });
    // images with no alt attribute at all: decorative when the text beside them already says it
    all('img:not([alt])').forEach(function (img) {
      var holder = img.closest('label,a,button');
      if (holder && text(holder)) { img.setAttribute('alt', ''); return; }
      var title = doc.querySelector('h1');
      var inProduct = img.closest('[class*="hadiproductpicture"],.product-form,.productView');
      img.setAttribute('alt', inProduct && title ? text(title) : '');
    });

    // controls that are announced with no name or with a broken translation
    all('button.btn-quantity,a.btn-quantity').forEach(function (b) {
      if (text(b) || b.getAttribute('aria-label')) return;
      b.setAttribute('aria-label', /minus/.test(b.className) ? 'Decrease quantity' : 'Increase quantity');
    });
    all('[aria-label^="Translation missing"],[title^="Translation missing"],[alt^="Translation missing"]').forEach(function (n) {
      ['aria-label', 'title', 'alt'].forEach(function (attr) {
        var v = n.getAttribute(attr);
        if (v && v.indexOf('Translation missing') === 0) n.setAttribute(attr, /close/i.test(v) ? 'Close' : (/search/i.test(v) ? 'Search' : 'Button'));
      });
    });
    all('a.halo-sidebar-close[href="#"]').forEach(function (a) { if (!a.getAttribute('role')) a.setAttribute('role', 'button'); });
    var pw = doc.getElementById('RegisterForm-password');
    if (pw && !pw.getAttribute('aria-label') && !(pw.labels && pw.labels.length)) pw.setAttribute('aria-label', 'Password');

    // product photos: each one gets its own description, and the small photos become real buttons
    var h1 = doc.querySelector('h1'), productName = h1 ? text(h1) : '';
    if (productName && doc.querySelector('.productView-image')) {
      var mains = all('.productView-image img[id^="product-featured-image"]').filter(function (i) { return !i.closest('.slick-cloned'); });
      mains.forEach(function (img, i) {
        var a = img.getAttribute('alt');
        if (!a || a === productName) img.setAttribute('alt', productName + (mains.length > 1 ? ', photo ' + (i + 1) + ' of ' + mains.length : ''));
      });
      var thumbs = all('.productView-thumbnail-link').filter(function (t) { return !t.closest('.slick-cloned') && shown(t); });
      thumbs.forEach(function (t, i) {
        if (!t.getAttribute('role')) { t.setAttribute('role', 'button'); t.setAttribute('tabindex', '0'); }
        var im = t.querySelector('img'), own = im ? im.getAttribute('alt') : '';
        // 2026-10-27: the photo keeps its own description (the button's name repeats it, so nothing is read twice)
        if (im && own && !t.getAttribute('data-fl-alt')) t.setAttribute('data-fl-alt', own);
        if (im && !own && t.getAttribute('data-fl-alt')) im.setAttribute('alt', t.getAttribute('data-fl-alt'));
        // a photo with no description in Shopify: use the same fallback as the large photo
        if (im && !im.getAttribute('alt') && mains[i]) { im.setAttribute('alt', mains[i].getAttribute('alt') || productName); t.setAttribute('data-fl-alt', im.getAttribute('alt')); }
        var label = 'Show photo ' + (i + 1) + ' of ' + thumbs.length + (t.getAttribute('data-fl-alt') ? ': ' + t.getAttribute('data-fl-alt') : '');
        if (t.getAttribute('aria-label') !== label) t.setAttribute('aria-label', label);
      });

      // heading levels on the product page
      all('h3.title').forEach(function (h) {
        if (!h.getAttribute('aria-level') && /related products|recently viewed|you may also like/i.test(text(h))) { h.setAttribute('role', 'heading'); h.setAttribute('aria-level', '2'); }
      });
      var notes = doc.querySelector('.hadinotes');
      if (notes && !notes.querySelector('.fl-a11y-notes-h')) {
        var nh = doc.createElement('h2'); nh.className = 'fl-a11y-sr fl-a11y-notes-h'; nh.textContent = 'Fragrance notes';
        notes.insertBefore(nh, notes.firstChild);
      }
      all('.hadiallnotes > span').forEach(function (sp) {
        if (!sp.getAttribute('role') && /notes$/i.test(text(sp))) { sp.setAttribute('role', 'heading'); sp.setAttribute('aria-level', '3'); }
      });
    }

    // product cards: one link per product for keyboard and screen reader, and "Shop Now" says what it shops
    all('.product-item').forEach(function (card) {
      var titleLink = card.querySelector('a.card-title');
      if (!titleLink) return;
      var name = text(titleLink), href = (titleLink.getAttribute('href') || '').split('?')[0];
      all('a[href]', card).forEach(function (a) {
        // other links to the same product page that add nothing (the picture, a wrapper): skipped by keyboard and screen reader
        if (a === titleLink || a.classList.contains('button') || a.getAttribute('tabindex') === '-1') return;
        if ((a.getAttribute('href') || '').split('?')[0] !== href) return;
        var t = text(a);
        if (!t || t === name) { a.setAttribute('tabindex', '-1'); a.setAttribute('aria-hidden', 'true'); }
      });
      all('a.button', card).forEach(function (a) {
        var t = text(a);
        if (name && !a.getAttribute('aria-label') && /^(shop now|choose options|select options|quick view|view|buy now)$/i.test(t)) a.setAttribute('aria-label', t + ': ' + name);
      });
    });

    // the cart icon must say how many items are in the cart (its hidden text stayed at "0 items")
    var counted = false;
    all('a.header__icon--cart').forEach(function (a) {
      var c = a.querySelector('[data-cart-count], .cart-count-bubble .text');
      if (!c) return;
      var n = parseInt(text(c), 10); if (isNaN(n)) n = 0;
      var words = n + (n === 1 ? ' item' : ' items');
      var hid = a.querySelector('.cart-count-bubble .visually-hidden');
      if (hid && text(hid) !== words) hid.textContent = words;
      if (a.getAttribute('aria-label') !== 'Cart, ' + words) a.setAttribute('aria-label', 'Cart, ' + words);
      if (!counted) {
        counted = true;
        if (cartCount !== null && n > cartCount) say('Added to cart. Your cart now has ' + words + '.');
        cartCount = n;
      }
    });

    // rotating messages must not be read out on every change
    all('.slick-initialized').forEach(function (sl) {
      var list = sl.querySelector('.slick-list');
      if (list && list.getAttribute('aria-live') !== 'off') list.setAttribute('aria-live', 'off');
    });

    // price blocks use list markup without list items
    all('dl').forEach(function (d) {
      if (d.getAttribute('role')) return;
      if (d.querySelector(':scope > span, :scope > small, :scope > div') || !d.querySelector('dt')) d.setAttribute('role', 'presentation');
    });
  }

  /* ---------- Pause control for auto-rotating content ---------- */
  function addPauseControls() {
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    all('.slick-initialized').forEach(function (s) {
      if (s.__flPause) return;
      var inst = s.slick;
      if (!inst || !inst.options || !inst.options.autoplay) return;
      var host = s.parentNode;
      if (!host) return;
      s.__flPause = true;
      if (window.getComputedStyle(host).position === 'static') host.style.position = 'relative';
      var b = doc.createElement('button');
      b.type = 'button';
      b.className = 'fl-a11y-pause' + (s.getBoundingClientRect().height < 70 ? ' fl-a11y-pause--bar' : '');
      function set(paused) {
        b.setAttribute('aria-pressed', paused ? 'true' : 'false');
        b.setAttribute('aria-label', paused ? 'Play moving content' : 'Pause moving content');
        b.textContent = paused ? '\u25B6' : '\u275A\u275A';
        try {
          if (paused) { (inst.slickPause || inst.pause).call(inst); }
          else { (inst.slickPlay || inst.play).call(inst); }
        } catch (err) {}
      }
      b.addEventListener('click', function () { set(b.getAttribute('aria-pressed') !== 'true'); });
      host.insertBefore(b, s);
      set(!!reduce);
      // previous / next, when the slider has no arrows of its own
      if (!all('.slick-arrow', s).filter(shown).length) {
        var bar = s.getBoundingClientRect().height < 70;
        ['prev', 'next'].forEach(function (dir) {
          var nb = doc.createElement('button');
          nb.type = 'button';
          nb.className = 'fl-a11y-pause fl-a11y-nav fl-a11y-nav--' + dir + (bar ? ' fl-a11y-pause--bar' : '');
          nb.setAttribute('aria-label', dir === 'prev' ? 'Previous message' : 'Next message');
          nb.textContent = dir === 'prev' ? '\u2039' : '\u203A';
          nb.addEventListener('click', function () {
            try { (dir === 'prev' ? (inst.slickPrev || inst.prev) : (inst.slickNext || inst.next)).call(inst); } catch (err) {}
            window.setTimeout(function () { var cur = s.querySelector('.slick-current'); if (cur && text(cur)) say(text(cur)); }, 700);
          });
          host.insertBefore(nb, b);
        });
        if (!host.getAttribute('role')) { host.setAttribute('role', 'region'); host.setAttribute('aria-label', bar ? 'Store announcements' : 'Carousel'); }
        // on a phone the three controls need their own room, so the message is not hidden under them
        if (bar) {
          host.classList.add('fl-a11y-hasnav');
          var again = function () { try { inst.setPosition(); } catch (err) {} };
          again(); window.setTimeout(again, 400);
        }
      }
    });
  }

  /* ===================== Added 2026-10-26 (WCAG 2.2 AA pass) ===================== */

  /* ---------- Carousels: no listbox / tab roles they do not support, and no focus inside hidden slides ---------- */
  function setTab(el, hide) {
    if (hide) {
      if (!el.hasAttribute('data-fl-tab')) el.setAttribute('data-fl-tab', el.hasAttribute('tabindex') ? el.getAttribute('tabindex') : 'none');
      if (el.getAttribute('tabindex') !== '-1') el.setAttribute('tabindex', '-1');
    } else if (el.hasAttribute('data-fl-tab')) {
      var o = el.getAttribute('data-fl-tab');
      el.removeAttribute('data-fl-tab');
      if (o === 'none') el.removeAttribute('tabindex'); else el.setAttribute('tabindex', o);
    }
  }
  function fixSlider(sl) {
    var track = sl.querySelector(':scope > .slick-list > .slick-track');
    if (track && track.getAttribute('role') === 'listbox') { track.removeAttribute('role'); if (track.getAttribute('aria-label') === 'Carousel') track.removeAttribute('aria-label'); }
    if (!track) return;
    all(':scope > .slick-slide', track).forEach(function (sd) {
      if (sd.getAttribute('role') === 'option' || sd.getAttribute('role') === 'tabpanel') sd.removeAttribute('role');
      if (sd.hasAttribute('aria-describedby') && /^slick-slide/.test(sd.getAttribute('aria-describedby'))) sd.removeAttribute('aria-describedby');
      if (sd.classList.contains('slick-cloned') && sd.getAttribute('aria-hidden') !== 'true') sd.setAttribute('aria-hidden', 'true');
      var hidden = sd.getAttribute('aria-hidden') === 'true';
      all(FOCUSABLE + ',[data-fl-tab]', sd).forEach(function (f) { setTab(f, hidden); });
    });
    var dots = sl.querySelector(':scope > .slick-dots');
    if (dots) {
      if (dots.getAttribute('role') === 'tablist') dots.removeAttribute('role');
      all(':scope > li', dots).forEach(function (li, i) {
        ['role', 'aria-selected', 'aria-controls', 'aria-hidden'].forEach(function (a) { if (li.hasAttribute(a)) li.removeAttribute(a); });
        var btn = li.querySelector('button');
        if (!btn) return;
        if (btn.getAttribute('tabindex') === '-1') btn.removeAttribute('tabindex');
        ['role', 'aria-selected', 'aria-controls'].forEach(function (a) { if (btn.hasAttribute(a) && a !== 'role') btn.removeAttribute(a); });
        var want = 'Show slide ' + (i + 1);
        if (btn.getAttribute('aria-label') !== want) btn.setAttribute('aria-label', want);
        var cur = li.classList.contains('slick-active');
        if (cur && btn.getAttribute('aria-current') !== 'true') btn.setAttribute('aria-current', 'true');
        if (!cur && btn.hasAttribute('aria-current')) btn.removeAttribute('aria-current');
      });
    }
    var list = sl.querySelector(':scope > .slick-list');
    if (list && list.getAttribute('aria-live') !== 'off') list.setAttribute('aria-live', 'off');
  }
  function fixSliders() {
    all('.slick-initialized').forEach(function (sl) {
      try { fixSlider(sl); } catch (err) {}
      // slick puts its own attributes back after every move: fix again straight away
      if (!sl.__flSlickEv && window.MutationObserver) {
        sl.__flSlickEv = true;
        // the fix runs before anything else can read the slider again (the changes below are only made when needed, so this settles)
        try {
          new MutationObserver(function () { try { fixSlider(sl); } catch (err) {} })
            .observe(sl, { attributes: true, subtree: true, attributeFilter: ['role', 'aria-hidden', 'aria-describedby', 'aria-selected', 'tabindex', 'aria-live'] });
        } catch (err) {}
      }
    });
  }

  /* ---------- Search suggestions panel (FL search): reachable by keyboard and closed when focus leaves ---------- */
  function searchPanel() { var p = doc.querySelector('.fls-panel'); return p && !p.hidden ? p : null; }
  var searchInput = null;
  function setupSearchKeys() {
    if (doc.__flSearchKeys) return;
    doc.__flSearchKeys = true;
    doc.addEventListener('keydown', function (e) {
      var t = e.target, p = searchPanel();
      if (t && t.matches && t.matches('form[role="search"] input[name="q"]')) {
        searchInput = t;
        if (p && ((e.key === 'Tab' && !e.shiftKey) || e.key === 'ArrowDown')) {
          var first = focusables(p)[0];
          if (first) { e.preventDefault(); first.focus(); }
        }
        return;
      }
      if (!p || !p.contains(t)) return;
      var f = focusables(p), i = f.indexOf(t);
      if (e.key === 'Escape' || e.key === 'Esc') { e.preventDefault(); p.hidden = true; if (searchInput) searchInput.focus(); }
      else if (e.key === 'ArrowDown' && i > -1 && i < f.length - 1) { e.preventDefault(); f[i + 1].focus(); }
      else if (e.key === 'ArrowUp') { e.preventDefault(); if (i > 0) f[i - 1].focus(); else if (searchInput) searchInput.focus(); }
      else if (e.key === 'Tab' && e.shiftKey && i === 0 && searchInput) { e.preventDefault(); searchInput.focus(); }
      else if (e.key === 'Tab' && !e.shiftKey && i === f.length - 1 && searchInput) {
        // leave the panel: close it and continue with whatever follows the search box
        e.preventDefault(); p.hidden = true;
        var order = all(FOCUSABLE).filter(shown), j = order.indexOf(searchInput);
        var next = j > -1 ? order[j + 1] : null;
        if (next) next.focus(); else searchInput.focus();
      }
    }, true);
    doc.addEventListener('focusin', function (e) {
      var p = searchPanel();
      if (!p || p.contains(e.target)) return;
      if (e.target.matches && e.target.matches('form[role="search"] input[name="q"]')) return;
      p.hidden = true;   // focus went elsewhere: the panel must not cover it (2.4.11)
    });
  }

  /* ---------- Escape dismisses a header menu opened by mouse hover (1.4.13) ---------- */
  function setupHoverEscape() {
    if (doc.__flHoverEsc) return;
    doc.__flHoverEsc = true;
    // keyboard in use: lets CSS show focus rings that :focus-visible cannot reach (Shop Pay buttons), for keyboard users only
    doc.addEventListener('keydown', function (e) { if (e.key === 'Tab' || /^Arrow/.test(e.key)) doc.documentElement.classList.add('fl-kbd'); }, true);
    doc.addEventListener('mousedown', function () { doc.documentElement.classList.remove('fl-kbd'); }, true);
    doc.addEventListener('touchstart', function () { doc.documentElement.classList.remove('fl-kbd'); }, { capture: true, passive: true });
    doc.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape' && e.key !== 'Esc') return;
      all('li.menu-lv-1.dropdown').forEach(function (li) { if (li.matches(':hover')) li.classList.add('fl-a11y-dismissed'); });
    });
    doc.addEventListener('mouseout', function (e) {
      var li = e.target && e.target.closest ? e.target.closest('li.menu-lv-1.fl-a11y-dismissed') : null;
      if (li && !li.contains(e.relatedTarget)) li.classList.remove('fl-a11y-dismissed');
    });
  }

  /* ---------- Product page tabs: real tabs on desktop, a disclosure on phones ---------- */
  function fixTabs() {
    all('product-tab ul.tabs').forEach(function (ul) {
      var links = all('a.tab-title', ul);
      if (!links.length) return;
      var desk = shown(ul);
      if (desk) {
        if (ul.getAttribute('role') !== 'tablist') ul.setAttribute('role', 'tablist');
        all(':scope > li', ul).forEach(function (li) { if (li.getAttribute('role') !== 'presentation') li.setAttribute('role', 'presentation'); });
        links.forEach(function (a, i) {
          var id = (a.getAttribute('href') || '').replace(/^.*#/, ''), panel = id ? doc.getElementById(id) : null;
          if (!a.id) a.id = 'fl-a11y-tab-' + i + '-' + id;
          if (a.getAttribute('role') !== 'tab') a.setAttribute('role', 'tab');
          var sel = a.classList.contains('is-open');
          if (a.getAttribute('aria-selected') !== String(sel)) a.setAttribute('aria-selected', String(sel));
          var ti = sel ? '0' : '-1';
          if (a.getAttribute('tabindex') !== ti) a.setAttribute('tabindex', ti);
          if (panel) {
            if (a.getAttribute('aria-controls') !== id) a.setAttribute('aria-controls', id);
            if (panel.getAttribute('role') !== 'tabpanel') { panel.setAttribute('role', 'tabpanel'); panel.setAttribute('aria-labelledby', a.id); }
          }
          if (!a.__flTab) {
            a.__flTab = true;
            a.addEventListener('keydown', function (e) {
              var list = all('a.tab-title', ul), k = list.indexOf(a), n = -1;
              if (e.key === 'ArrowRight') n = (k + 1) % list.length;
              else if (e.key === 'ArrowLeft') n = (k - 1 + list.length) % list.length;
              else if (e.key === 'Home') n = 0;
              else if (e.key === 'End') n = list.length - 1;
              else if (e.key === ' ' || e.key === 'Spacebar') { e.preventDefault(); a.click(); return; }
              if (n < 0) return;
              e.preventDefault(); list[n].click(); list[n].focus();
              window.setTimeout(fixTabs, 60);
            });
            a.addEventListener('click', function () { window.setTimeout(fixTabs, 60); });
          }
        });
      }
    });
    // phone layout: each section header opens a full-screen pop-up, which must behave as a dialog
    all('a.toggleLink[data-collapsible]').forEach(function (a) {
      var holder = a.closest('.tab-content');
      var body = holder ? holder.querySelector('.toggle-content') : null;
      if (!body) return;
      if (!body.id) body.id = 'fl-a11y-tc-' + (holder.id || Math.random().toString(36).slice(2));
      var isPopup = body.classList.contains('popup-mobile');
      var open = isPopup ? body.classList.contains('is-show') : shown(body);
      if (shown(a)) {
        if (a.getAttribute('role') !== 'button') a.setAttribute('role', 'button');
        if (isPopup && a.getAttribute('aria-haspopup') !== 'dialog') a.setAttribute('aria-haspopup', 'dialog');
        if (a.getAttribute('aria-expanded') !== String(open)) a.setAttribute('aria-expanded', String(open));
        if (a.getAttribute('aria-controls') !== body.id) a.setAttribute('aria-controls', body.id);
        if (!a.__flTog) {
          a.__flTog = true;
          a.addEventListener('click', function () { lastPopupOpener = a; window.setTimeout(fixTabs, 400); });
          a.addEventListener('keydown', function (e) { if (e.key === ' ' || e.key === 'Spacebar') { e.preventDefault(); a.click(); } });
        }
      }
      if (!isPopup) return;
      if (body.getAttribute('role') !== 'dialog') {
        body.setAttribute('role', 'dialog'); body.setAttribute('aria-modal', 'true');
        var h = body.querySelector('.tab-popup-header h5, .tab-popup-header .text');
        if (h) { if (!h.id) h.id = body.id + '-title'; body.setAttribute('aria-labelledby', h.id); }
        if (!body.hasAttribute('tabindex')) body.setAttribute('tabindex', '-1');
      }
      var x = body.querySelector('.pdViewTab-close');
      if (x && !x.__flX) {
        x.__flX = true;
        x.removeAttribute('aria-disabled'); x.setAttribute('role', 'button'); x.setAttribute('tabindex', '0'); x.setAttribute('aria-label', 'Close');
        x.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') { e.preventDefault(); x.click(); } });
      }
      if (open && openPopup !== body) {
        openPopup = body;
        window.setTimeout(function () { if (openPopup === body && !body.contains(doc.activeElement)) { try { (x || body).focus(); } catch (err) {} } }, 350);
      } else if (!open && openPopup === body) {
        openPopup = null;
        var back = lastPopupOpener; lastPopupOpener = null;
        if (back && shown(back)) { try { back.focus(); } catch (err) {} }
      }
    });
    if (!doc.__flPopupKeys) {
      doc.__flPopupKeys = true;
      doc.addEventListener('keydown', function (e) {
        var p = openPopup;
        if (!p || !p.classList.contains('is-show')) return;
        var x = p.querySelector('.pdViewTab-close');
        if (e.key === 'Escape' || e.key === 'Esc') { if (x) { e.preventDefault(); x.click(); } return; }
        if (e.key !== 'Tab') return;
        var f = focusables(p);
        if (!f.length) { e.preventDefault(); p.focus(); return; }
        var first = f[0], last = f[f.length - 1], cur = doc.activeElement;
        if (!p.contains(cur)) { e.preventDefault(); first.focus(); }
        else if (e.shiftKey && cur === first) { e.preventDefault(); last.focus(); }
        else if (!e.shiftKey && cur === last) { e.preventDefault(); first.focus(); }
      }, true);
    }
  }
  var openPopup = null, lastPopupOpener = null;

  /* ---------- Cart drawer and cart page ---------- */
  function fixCart() {
    var rows = all('#halo-cart-sidebar .previewCartItem, .cart-item, [data-cart-item]');
    rows.forEach(function (row) {
      var nameEl = row.querySelector('a.previewCartItem-name, .previewCartItem-name a, a.cart-item-name, .cart-item-name a, .cart-item-name');
      var name = nameEl ? text(nameEl) : '';
      if (!name) return;
      all('input.cart-item-qty-input, input[id^="upsell-update-"], input[name="quantity"], input[name="updates[]"]', row).forEach(function (inp) {
        var want = 'Quantity for ' + name;
        if (inp.getAttribute('aria-label') !== want) inp.setAttribute('aria-label', want);
      });
      all('button.previewCartItem-remove, .previewCartItem-remove, .cart-remove, a.cart-remove, cart-remove-button a, cart-remove-button button, a[href*="/cart/change"][href*="quantity=0"]', row).forEach(function (r) {
        var want = 'Remove ' + name;
        if (r.getAttribute('aria-label') !== want) r.setAttribute('aria-label', want);
      });
      all('button.btn-quantity, a.btn-quantity', row).forEach(function (b) {
        var want = (/minus/.test(b.className) ? 'Decrease quantity of ' : 'Increase quantity of ') + name;
        if (b.getAttribute('aria-label') !== want) b.setAttribute('aria-label', want);
      });
      // the picture repeats the name link: one link per item
      all('a.previewCartItem-image, a.cart-item-image', row).forEach(function (a) {
        if (text(a)) return;
        if (a.getAttribute('tabindex') !== '-1') { a.setAttribute('tabindex', '-1'); a.setAttribute('aria-hidden', 'true'); }
      });
    });
    // shipping protection checkbox: name it from the text beside it
    all('#shippingProtectionCheckBox').forEach(function (cb) {
      if (cb.getAttribute('aria-labelledby')) return;
      var wrap = cb.closest('.d-flexCstm-ld, #nvd-widget-cart') || cb.parentElement.parentElement;
      var parts = wrap ? all('h1,h2,h3,h4,h5,h6,p', wrap).filter(function (n) { return shown(n) && text(n) && !n.querySelector('p'); }).slice(0, 2) : [];
      if (parts.length) {
        var ids = parts.map(function (n, k) { if (!n.id) n.id = 'fl-a11y-shipprot-' + k + '-' + Math.random().toString(36).slice(2, 7); return n.id; });
        cb.setAttribute('aria-labelledby', ids.join(' '));
        cb.removeAttribute('aria-label');
      } else if (!cb.getAttribute('aria-label')) cb.setAttribute('aria-label', 'Shipping protection');
    });
    // totals list holds div rows
    all('ul.cart-totals').forEach(function (ul) {
      if (ul.querySelector(':scope > div')) {
        if (ul.getAttribute('role') !== 'list') ul.setAttribute('role', 'list');
        all(':scope > div', ul).forEach(function (d) { if (d.getAttribute('role') !== 'listitem') d.setAttribute('role', 'listitem'); });
      }
    });
    // "Continue Shopping" in the empty cart drawer is a link with no address: make it work by keyboard
    all('a.button-continue:not([href])').forEach(function (a) {
      if (a.__flCont) return;
      a.__flCont = true;
      a.removeAttribute('aria-disabled'); a.setAttribute('role', 'button'); a.setAttribute('tabindex', '0');
      a.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar') { e.preventDefault(); a.click(); } });
    });
  }

  /* ---------- Pause control for background video (2.2.2) ---------- */
  function fixVideos() {
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    all('video[autoplay]').forEach(function (v) {
      if (v.__flPause || v.controls) return;
      var host = v.parentNode;
      if (!host) return;
      v.__flPause = true;
      if (window.getComputedStyle(host).position === 'static') host.style.position = 'relative';
      var b = doc.createElement('button');
      b.type = 'button'; b.className = 'fl-a11y-pause fl-a11y-pause--video';
      function set(paused) {
        b.setAttribute('aria-pressed', paused ? 'true' : 'false');
        b.setAttribute('aria-label', paused ? 'Play background video' : 'Pause background video');
        b.textContent = paused ? '▶' : '❚❚';
        try { if (paused) v.pause(); else { var pr = v.play(); if (pr && pr.catch) pr.catch(function () {}); } } catch (err) {}
      }
      b.addEventListener('click', function () { set(b.getAttribute('aria-pressed') !== 'true'); });
      host.appendChild(b);
      set(!!reduce);
    });
  }

  /* ---------- Everything else ---------- */
  function fixMore() {
    fixCart();
    fixTabs();
    fixVideos();
    setupSearchKeys();
    setupHoverEscape();

    var tree = doc.getElementById('gf-tree');
    // closed filter drawer (phone): aria-hidden, so its controls must not take focus either
    if (tree && 'inert' in tree) {
      var closed = tree.getAttribute('aria-hidden') === 'true';
      if (tree.inert !== closed) tree.inert = closed;
    }

    // a way past the long filter list straight to the products (2.4.1)
    var grid = doc.getElementById('gf-products');
    if (tree && grid && !doc.getElementById('fl-a11y-skip-products')) {
      var sk = doc.createElement('a');
      sk.id = 'fl-a11y-skip-products'; sk.href = '#gf-products'; sk.className = 'fl-a11y-skip';
      sk.textContent = 'Skip filters, go to products';
      sk.addEventListener('click', function (e) {
        e.preventDefault();
        var g = doc.getElementById('gf-products');
        if (!g) return;
        if (!g.hasAttribute('tabindex')) g.setAttribute('tabindex', '-1');
        if (!g.getAttribute('aria-label')) g.setAttribute('aria-label', 'Products');
        g.focus(); g.scrollIntoView({ block: 'start' });
      });
      tree.parentNode.insertBefore(sk, tree);
    }

    // price slider handles: the Min / Max boxes beside them are the keyboard and screen reader route
    all('.noUi-handle[tabindex="0"]').forEach(function (h) {
      var box = h.closest('.gf-option-block, .gf-block-content, [class*=filter]');
      if (box && box.querySelector('input[type=number], input[type=text], input.gf-range-min, input[name*=min i]')) {
        h.setAttribute('tabindex', '-1'); h.setAttribute('aria-hidden', 'true');
      }
    });

    // closed share pop-over: nothing inside it may take focus, and Share says whether it is open
    all('share-button').forEach(function (sb) {
      var btn = sb.querySelector('.share-button__button'), fb = sb.querySelector('.share-button__fallback');
      if (!btn || !fb) return;
      var open = window.getComputedStyle(fb).opacity !== '0' && window.getComputedStyle(fb).visibility !== 'hidden' && window.getComputedStyle(fb).display !== 'none';
      if (!fb.id) fb.id = 'fl-a11y-share-' + Math.random().toString(36).slice(2, 8);
      if (btn.getAttribute('aria-expanded') !== String(open)) btn.setAttribute('aria-expanded', String(open));
      if (btn.getAttribute('aria-controls') !== fb.id) btn.setAttribute('aria-controls', fb.id);
      if ('inert' in fb && fb.inert !== !open) fb.inert = !open;
      if (!btn.__flShare) {
        btn.__flShare = true;
        btn.addEventListener('click', function () {
          [50, 400].forEach(function (ms) {
            window.setTimeout(function () {
              var nowOpen = window.getComputedStyle(fb).opacity !== '0';
              fb.inert = !nowOpen; btn.setAttribute('aria-expanded', String(nowOpen));
              if (nowOpen && ms === 400 && !fb.contains(doc.activeElement)) { var c = fb.querySelector('.share-button__close'); if (c) c.focus(); }
            }, ms);
          });
        });
        sb.addEventListener('keydown', function (e) {
          if ((e.key === 'Escape' || e.key === 'Esc') && !fb.inert) { var c = fb.querySelector('.share-button__close'); if (c) { e.preventDefault(); c.click(); btn.focus(); } }
        });
        var cl = fb.querySelector('.share-button__close');
        if (cl) cl.addEventListener('click', function () { window.setTimeout(function () { fb.inert = true; btn.setAttribute('aria-expanded', 'false'); btn.focus(); }, 60); });
      }
    });

    // "View All" says what it views (2.4.4)
    all('.halo-block-header a.view_all').forEach(function (a) {
      if (a.getAttribute('aria-label')) return;
      var hb = a.closest('.halo-block-header'), h = hb ? hb.querySelector('h1,h2,h3,h4,.title') : null;
      if (h && text(h)) a.setAttribute('aria-label', 'View all ' + text(h));
    });

    // Judge.me star badge: say the rating and where it goes
    all('.jdgm-prev-badge__stars[role="button"]').forEach(function (s) {
      var badge = s.closest('.jdgm-prev-badge');
      if (!badge) return;
      var n = badge.getAttribute('data-number-of-reviews'), avg = parseFloat(badge.getAttribute('data-average-rating') || s.getAttribute('data-score') || '0');
      var want = +n > 0 ? 'Rated ' + avg.toFixed(1) + ' out of 5 from ' + n + (+n === 1 ? ' review' : ' reviews') + '. Go to reviews' : 'No reviews yet. Go to reviews';
      if (s.getAttribute('aria-label') !== want) s.setAttribute('aria-label', want);
    });

    // input purpose (1.3.5)
    all('input[name="customer[email]"]:not([autocomplete])').forEach(function (i) { i.setAttribute('autocomplete', 'email'); });
    all('input[name="customer[password]"]:not([autocomplete])').forEach(function (i) {
      var f = i.form, isNew = !!(f && (f.querySelector('input[name="customer[first_name]"]') || /register|create/i.test(f.id || '')));
      i.setAttribute('autocomplete', isNew ? 'new-password' : 'current-password');
    });
    all('input[name="customer[first_name]"]:not([autocomplete])').forEach(function (i) { i.setAttribute('autocomplete', 'given-name'); });
    all('input[name="customer[last_name]"]:not([autocomplete])').forEach(function (i) { i.setAttribute('autocomplete', 'family-name'); });

    // headings: empty ones are not headings; levels that skip straight down after the page title
    all('h1,h2,h3,h4,h5,h6').forEach(function (h) {
      var empty = !text(h) && !h.querySelector('img[alt]:not([alt=""])');
      if (empty && h.getAttribute('role') !== 'none') { h.setAttribute('role', 'none'); h.setAttribute('data-fl-empty-h', '1'); }
      else if (!empty && h.getAttribute('data-fl-empty-h')) { h.removeAttribute('role'); h.removeAttribute('data-fl-empty-h'); }   // a pop-up filled its title later
    });
    // small pictures inside a size / option label repeat what the label text says: decorative
    all('label.product-form__label img[alt=""]:not([role])').forEach(function (im) { if (text(im.closest('label'))) im.setAttribute('role', 'presentation'); });
    all('.travel_spray_content > h3').forEach(function (h) { if (!h.getAttribute('aria-level')) { h.setAttribute('role', 'heading'); h.setAttribute('aria-level', '2'); } });
    if (/\btemplate-cart\b/.test(doc.body.className)) {
      all('h4.cart-item-name, .cart-item-name h4, h4').forEach(function (h) {
        if (h.closest('.cart-item, [data-cart-item], .cart-items, cart-items') && !h.getAttribute('aria-level')) { h.setAttribute('role', 'heading'); h.setAttribute('aria-level', '2'); }
      });
    }
  }

  /* ---------- Run now and whenever the page changes ---------- */
  var timer = null;
  function run() {
    timer = null;
    try { syncPanels(); } catch (err) {}
    try { fixMarkup(); } catch (err) {}
    try { addPauseControls(); } catch (err) {}
    try { setupMenus(); } catch (err) {}
    try { fixMore(); } catch (err) {}
  }
  function schedule() { if (!timer) timer = window.setTimeout(run, 250); }

  function start() {
    run();
    if (window.MutationObserver) {
      new MutationObserver(function (muts) {
        // new product cards: fix their price lists at once, before anything reads them (the full pass follows in 250 ms)
        var sliderNow = false;
        for (var i = 0; i < muts.length; i++) {
          var mt = muts[i].target;
          if (muts[i].type === 'attributes' && mt.classList && mt.classList.contains('slick-initialized') && !mt.__flSlickEv) sliderNow = true;
          var added = muts[i].addedNodes;
          for (var j = 0; added && j < added.length; j++) {
            var n = added[j];
            if (n.nodeType !== 1) continue;
            if (!sliderNow && (n.classList.contains('slick-initialized') || (n.querySelector && n.querySelector('.slick-initialized')))) sliderNow = true;
            var dls = n.tagName === 'DL' ? [n] : (n.querySelectorAll ? n.querySelectorAll('dl:not([role])') : []);
            for (var k = 0; k < dls.length; k++) {
              var d = dls[k];
              if (!d.getAttribute('role') && (d.querySelector(':scope > span, :scope > small, :scope > div') || !d.querySelector('dt'))) d.setAttribute('role', 'presentation');
            }
          }
        }
        // a slider that has just been set up: remove its unsupported roles straight away
        if (sliderNow) { try { fixSliders(); } catch (err) {} }
        schedule();
      }).observe(doc.body, { attributes: true, attributeFilter: ['class', 'role'], childList: true, subtree: true });
    }
    window.setTimeout(run, 1500);
    window.setTimeout(run, 4000);
  }
  if (doc.readyState === 'loading') doc.addEventListener('DOMContentLoaded', start); else start();
})();
